"use client";

import React from "react";
import styled, { css } from "styled-components";
import Link from "next/link";
import { Icon, utils } from "@thenounproject/lingo-core";

const Wrapper = styled(Link)`
  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    span {
      ${css`
        ${utils.getFont("ui.small", null)}
      `};
      ${utils.positioningCSS({ mt: "xs" })};
      color: ${utils.getColor("white")};
    }
  }
  a,
  button {
    svg,
    span {
      transition: 0.3s ease;
    }
  }
`;

export default function LoginBadge() {
  return (
    <Wrapper href={`/login?next=${window.location.toString()}`}>
      <button>
        <Icon iconId="lock-open" fill="white" />
        <span>Log in</span>
      </button>
    </Wrapper>
  );
}
